<template>
    <div class="home">
        <Home v-if="isLoggedIn" :loginState="isLoggedIn" msg="Welcome to Your Vue.js App" />
        <Login v-else></Login>
    </div>
</template>

<script>
import Home from "@/components/Home.vue";
import Login from "@/components/Login.vue";

export default {
    name: "HomeView",
    components: {
        Home,
        Login
    },
    computed: {
        isLoggedIn() {
            return this.$session.exists();
        }
    }
};
</script>
